var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('YA_Snackbar',{ref:"YA_SnackbarRef"}),_c('v-row',{staticClass:"justify-center",attrs:{"no-gutters":""}},[_c('v-col',{attrs:{"cols":"12","sm":"12","md":"2","lg":"2","xl":"2"}},[_c('PowerChatLeftBar')],1),_c('v-col',{attrs:{"cols":"12","sm":"12","md":"10","lg":"10","xl":"10"}},[_c('keep-alive',[_c('router-view')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }